import { clamp } from 'lodash';

import { RankingInterface } from '@/types';

interface Props {
  list: RankingInterface[];
  highlightedItemId: string;
  maxListLength: number;
}

export const getSectionOfListAroundItem = ({ list, highlightedItemId, maxListLength }: Props) => {
  const highlightedIndex = list.findIndex((item) => item.id === highlightedItemId);
  // Calculate the start index ensuring it's within bounds
  // and accounts for max list length
  const startIndex = clamp(highlightedIndex - 1, 0, list.length - maxListLength);
  // Determine the end index, ensuring it does not exceed the list length
  const endIndex = Math.min(startIndex + maxListLength, list.length);

  return list.slice(startIndex, endIndex);
};
